import React from 'react';

import { ActivePagePropsType } from '@ts/internalSidebar.types';

import ConfigurableSidebar from '@uikit/old/ConfigurableSidebar/ConfigurableSidebar';

import sidebarConfig from './sidebarConfig';

import './SettingsSidebar.scss';

function SidebarHeader() {
  return <span>Settings</span>;
}

function SettingsSidebar({ pathname }: ActivePagePropsType): JSX.Element {
  return (
    <div className="settings-sidebar">
      <ConfigurableSidebar
        config={sidebarConfig}
        renderProps={{ pathname }}
        SidebarHeader={SidebarHeader}
      />
    </div>
  );
}

export default SettingsSidebar;
